// Textos usados nas rotas públicas. O título ganha o sufixo " | Velz" no SeoService.
// title/description ficam em português como reserva; titleKey/descriptionKey são traduzidos no SeoService.
export const SEO = {
  home: {
    title: 'Aluguel de Carros em Cuiabá | Velz Rent a Car',
    description:
      'Alugue seu carro em Cuiabá com a Velz Rent a Car. Conheça nossos veículos, consulte disponibilidade e faça sua reserva online.',
    titleKey: 'seo.homeTitle',
    descriptionKey: 'seo.homeDesc',
  },
  tercerizacao: {
    title: 'Terceirização de frota',
    description: 'Terceirização de frota com a Velz. Veículos para empresas, com gestão e locação de longo prazo.',
    titleKey: 'seo.outsourceTitle',
    descriptionKey: 'seo.outsourceDesc',
  },
  assinatura: {
    title: 'Assinatura de carros',
    description: 'Assinatura de carros na Velz. Use um veículo por mensalidade, sem a burocracia de comprar.',
    titleKey: 'seo.subscriptionTitle',
    descriptionKey: 'seo.subscriptionDesc',
  },
  seminovos: {
    title: 'Seminovos',
    description: 'Seminovos Velz. Carros revisados, com procedência, prontos para comprar.',
    titleKey: 'seo.usedTitle',
    descriptionKey: 'seo.usedDesc',
  },
  noticias: {
    title: 'Notícias e avaliações',
    description: 'Notícias, avaliações e dicas da Velz sobre locação, frota, seminovos e mobilidade.',
    titleKey: 'seo.newsTitle',
    descriptionKey: 'seo.newsDesc',
  },
  about: {
    title: 'Sobre a Velz',
    description: 'Conheça a Velz, locadora de veículos com terceirização de frota, assinatura e seminovos.',
    titleKey: 'seo.aboutTitle',
    descriptionKey: 'seo.aboutDesc',
  },
  contacts: {
    title: 'Fale conosco',
    description: 'Fale com a Velz. Atendimento para locação, frota, assinatura e seminovos.',
    titleKey: 'seo.contactsTitle',
    descriptionKey: 'seo.contactsDesc',
  },
  help: {
    title: 'Central de ajuda',
    description: 'Central de ajuda da Velz. Respostas sobre reserva, locação e os serviços da locadora.',
    titleKey: 'seo.helpTitle',
    descriptionKey: 'seo.helpDesc',
  },
  termos: {
    title: 'Termos de uso',
    description: 'Termos de uso do site da Velz Rent A Car LTDA.',
    titleKey: 'seo.termsTitle',
    descriptionKey: 'seo.termsDesc',
  },
  privacidade: {
    title: 'Política de privacidade',
    description: 'Política de privacidade da Velz Rent A Car LTDA. Como tratamos seus dados pessoais (LGPD).',
    titleKey: 'seo.privacyTitle',
    descriptionKey: 'seo.privacyDesc',
  },
  excluirDados: {
    title: 'Solicitar exclusão de dados',
    description: 'Solicite exclusão e outros direitos sobre dados pessoais junto à Velz Rent A Car LTDA (LGPD).',
    titleKey: 'seo.deleteTitle',
    descriptionKey: 'seo.deleteDesc',
  },
  catalogoSeminovos: {
    title: 'Catálogo de seminovos',
    description: 'Catálogo de seminovos Velz. Filtre por marca, preço e carroceria.',
    titleKey: 'seo.catalogUsedTitle',
    descriptionKey: 'seo.catalogUsedDesc',
  },
  catalogoAluguel: {
    title: 'Carros para aluguel',
    description: 'Carros para aluguel diário na Velz. Veja grupos, preços e disponibilidade.',
    titleKey: 'seo.catalogRentTitle',
    descriptionKey: 'seo.catalogRentDesc',
  },
  catalogoTercerizacao: {
    title: 'Ofertas de terceirização',
    description: 'Ofertas de terceirização de frota na Velz para empresas.',
    titleKey: 'seo.catalogOutsourceTitle',
    descriptionKey: 'seo.catalogOutsourceDesc',
  },
  catalogoAssinatura: {
    title: 'Ofertas de assinatura',
    description: 'Ofertas de assinatura de carros na Velz, com mensalidade e frota revisada.',
    titleKey: 'seo.catalogSubscriptionTitle',
    descriptionKey: 'seo.catalogSubscriptionDesc',
  },
  page404: {
    title: 'Página não encontrada',
    description: 'A página solicitada não existe no site da Velz.',
    robots: 'noindex,follow',
    titleKey: 'seo.notFoundTitle',
    descriptionKey: 'seo.notFoundDesc',
  },
} as const;
